import i18n from '@/plugins/i18n';
import utils from '@/utils/functions';
import store from '@/state/store';

const staticData = () => {
  store.state.companySettings;
  const shouldHideCpa = utils.checkOcultarCpa();

  const columns = [
    {
      key: 'name',
      label: i18n.t('Name'),
      custom_class: 'text-left'
    },
    {
      key: 'sub_brand_name',
      label: i18n.t('Sub Brand'),
      custom_class: 'text-left'
    },
    {
      key: 'active_customers_count',
      label: i18n.t('Users'),
      custom_class: 'text-center'
    },
    {
      key: 'reward_accumulative',
      label: i18n.t('Comissão'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    },
    {
      key: 'reward_total',
      label: i18n.t('Valor a Pagar'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    }
  ];

  if (!shouldHideCpa) {
    columns.push(
      {
        key: 'reward_mark_count',
        label: i18n.t('Qty. CPA'),
        custom_class: 'text-center'
      },
      {
        key: 'reward_mark',
        label: i18n.t('CPA'),
        formatter: utils.formatMoneyFloat,
        custom_class: 'text-center'
      }
    );
  }

  return {
    columns
  };
};

export default staticData;
